<template>
    <div class="page-wrapper">
        <div class="page-section">
            <div class="cg-crumb">
                <btn-back />
                <span class="item">订单管理</span>
                <em class="gap">/</em>
                <span class="item">下单详情</span>
            </div>
            <div class="cg-main-title">下单详情</div>
            <div class="header-handle-box">
                <h3 class="state">
                    当前下单状态：
                    {{beCleared ? '已转为清算' : (status_pass + ' ' +status_pay)}}
                    <!-- <span class="tip-small" v-if="orderState == 2">待销售商进行核销</span> -->
                </h3>
                <div class="btns">
                    <button class="cg-btn red big" @click="toClearPage" v-if="beCleared">查看清算</button>
                    <button class="cg-btn red big" @click="toStartClear" v-else>发起清算</button>
                </div>
            </div>
            
            <div class="order-detail-table">
                <table class="table">
                    <tr class="th">
                        <th width="40%">商品</th>
                        <th width="20%">款号</th>
                        <th width="20%">采购方</th>
                        <th width="20%">总下单数</th>
                    </tr>
                    <tr>
                        <td>
                            <div class="td-1-wrap">
                                <el-image
                                    class="img"
                                    :src="imgUrl"
                                    fit="cover"
                                    :preview-src-list="srcList"
                                ></el-image>
                                <div class="title">{{orderDetail.item_name}}</div>
                            </div>
                        </td>
                        <td>{{orderDetail.item_style_number}}</td>
                        <td>{{orderDetail.dealerName}}</td>
                        <td>{{orderDetail.order_purchase_quantity}}</td>
                    </tr>
                </table>
                <div class="rate-info">说明：分佣比例为“销售商 : 供应商={{orderDetail.dealer_rate}}% : {{orderDetail.supplier_rate}}%”；平台服务费为您分佣后获得收益的{{serviceFeeShow}}，如 单件所收服务费=单价x分佣比例x{{serviceFeeShow}}</div>
                <div class="address-wrap" v-if="orderDetail.addressInfo">
                    <div class="address-label">销售商收货地址</div>
                    <div class="address-content">
                        <div class="line">
                            <span>姓名：{{orderDetail.addressInfo.address_contact_name}}</span>
                            <span class="gap">手机号：{{orderDetail.addressInfo.address_contact_phone}}</span>
                        </div>
                        <div class="line">地址：
                            {{orderDetail.addressInfo.region_province_string }}
                            {{orderDetail.addressInfo.region_city_string }}
                            {{orderDetail.addressInfo.region_district_string }}
                            {{orderDetail.addressInfo.address_string }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
        <div class="page-section" v-if="billList_platform.length > 0">
            <div class="cg-mod-title mgt-0">平台结款周期</div>
            <ul class="time-line">
                <li class="item" v-for="(item, index) in billList_platform" :key="index">
                    <div class="item-tail"></div>
                    <div class="item-node"></div>
                    <div class="item-content">
                        <div class="item-tit">
                            <strong class="item-tit-strong">平台第{{billList_platform.length - index}}个结款周期</strong>
                            <span class="item-tit-during">（{{item.bill_start_time}} 至 {{item.bill_end_time}}）</span>
                        </div>
                        <div class="item-sum-data">
                            本周期账单总金额：<span class="val">{{item.order_bill_amount}}  元</span><br>
                            平台已支付总金额（被供应商确认）：<span class="val">{{item.order_pay_amount}} </span>元<br>
                            平台已支付总金额（未被供应商确认）：<span  class="val">{{item.amountToBeConfirmed || 0}} 元</span><br>
                            平台还需支付总金额：<span class="red val">{{item.rest_pay_amount}} 元</span><br>
                        </div>
                        <div class="item-box">
                            <ul class="sub-time-line">
                               <template v-if="item.orderTransferList">
                                <li  class="sub-item" v-for="(pay_ele, pay_i) in item.orderTransferList" :key="pay_i">
                                  <div class="pdb-12">
                                    <span class="title"> 
                                        <span class="time">{{pay_ele.order_submit_time}}</span>
                                        平台方上传了结款凭证，支付了{{pay_ele.order_payment_amount}}元
                                    </span>
                                     <el-tag type="success" v-if="pay_ele.order_state == 'y'">供应商已确认</el-tag>
                                     <el-tag type="warning" v-if="pay_ele.order_state == 'p'">待供应商确认</el-tag>
                                     <el-tag type="danger" v-if="pay_ele.order_state == 'n'">供应商已拒绝</el-tag>
                                     
                                     <button class="cg-btn red-border mgl-16" v-if="!beCleared && !pay_ele.order_last_update_time" @click="getPlatformPayDetail(item, pay_ele)">确认平台付款凭证</button>
                                  </div>
                                  <div class="pdb-12">
                                    <template v-for="(img_ele, img_index) in pay_ele.imageFiles">
                                        <el-image
                                          :key="img_index"
                                          v-if="img_ele"
                                          class="img"
                                          :src="img_ele"
                                          fit="cover"
                                          :preview-src-list="pay_ele.imageFiles"
                                      ></el-image>
                                    </template>
                                    
                                    <span v-if="pay_ele.order_payment_memo" class="pay-info grey">
                                      说明：{{pay_ele.order_payment_memo}}
                                    </span>
                                  </div>
                                </li>
                              </template>
                               <li class="sub-item">
                                   <div class="pdb-6">
                                       <span class="time">{{item.order_submit_time}}</span>
                                       系统依据平台规则向您发布了以上已核销且销售商已付款的订单明细。
                                    </div>
                                    <div class="grey pdb-12">
                                       本期平台应向您支付<span>{{item.order_bill_amount}}</span>元
                                    </div>
                               </li>
                           </ul>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div class="page-section" v-if="billList_dealer.length > 0">
            <div class="cg-mod-title mgt-0">销售商付款周期</div>
            <ul class="time-line">
                <li class="item" v-for="(item, index) in billList_dealer" :key="index">
                    <div class="item-tail"></div>
                    <div class="item-node"></div>
                    <div class="item-content">
                        <div class="item-tit">
                            <strong class="item-tit-strong">销售商第{{billList_dealer.length - index}}个付款周期</strong>
                            <span class="item-tit-during">（{{item.bill_start_time}} 至 {{item.bill_end_time}}）</span>
                        </div>
                        <div class="item-sum-data">
                            本周期内已核销总数：<span class="val">{{item.orderEstablishList[0] ? (item.orderEstablishList[item.orderEstablishList.length-1].beforeOrderQuantity - item.orderEstablishList[0].restQuantity) : 0}}件</span><br>
                            本周期账单总金额：<span class="val">{{item.order_bill_amount}}  元</span><br>
                            本期账单销售商累计成功支付（被平台确认）：<span class="val">{{item.order_pay_amount || 0}} 元</span><br>
                            本期账单销售商提交且未被平台确认金额：<span  class="val">{{item.amountToBeConfirmed || 0}} 元</span><br>
                            本期账单销售商需再提交支付金额：<span class="red val">{{item.rest_pay_amount_subConfirm}} 元</span><br>
                        </div>
                        <div class="item-box">                   
                            <ul class="sub-time-line">
                              <template v-if="item.orderPaymentList">
                                <li  class="sub-item" v-for="(pay_ele, pay_i) in item.orderPaymentList" :key="pay_i">
                                  <div class="pdb-12">
                                    <span class="title">
                                       <span class="time">{{pay_ele.order_submit_time}}</span>
                                       销售商上传了付款凭证，支付了{{pay_ele.order_payment_amount}}元
                                    </span>
                                    <el-tag type="success" v-if="pay_ele.order_state == 'y'">平台已确认</el-tag>
                                    <el-tag type="danger" v-if="pay_ele.order_state == 'n'">平台已拒绝</el-tag>
                                    <el-tag type="warning" v-if="pay_ele.order_state == 'p'">待平台审核</el-tag>
                                  </div>
                                  <div class="pdb-12">
                                    <template v-for="(img_ele, img_index) in pay_ele.imageFiles">
                                        <el-image
                                          :key="img_index"
                                          v-if="img_ele"
                                          class="img"
                                          :src="img_ele"
                                          fit="cover"
                                          :preview-src-list="pay_ele.imageFiles"
                                      ></el-image>
                                    </template>
                                    
                                    <span v-if="pay_ele.order_payment_memo" class="pay-info grey">
                                      说明：{{pay_ele.order_payment_memo}}
                                    </span>
                                  </div>
                                  <!-- <div v-if="pay_ele.order_payment_memo" class="pdb-12 grey">
                                    说明：{{pay_ele.order_payment_memo}}
                                  </div> -->

                                </li>
                              </template>
                              
                              <!-- <li class="sub-item">
                                  <div class="pdb-12">销售商于2020年4月1日 12:30:40上传了付款凭证。</div>
                              </li>
                              <li class="sub-item">
                                  <div class="pdb-12">平台于2020年3月23日 16：12：32 确认了销售的付款</div>
                              </li> -->
                              <li class="sub-item">
                                  <div class="pdb-6">
                                      <span class="time">{{item.order_submit_time}}</span>
                                    系统依据平台规则向销售商发布了付款账单
                                    </div>
                                  <div class="grey pdb-12">
                                      销售商本次付款周期期间明细账单：<br>
                                      本周期内已核销总数：{{item.orderEstablishList[0] ? (item.orderEstablishList[item.orderEstablishList.length-1].beforeOrderQuantity - item.orderEstablishList[0].restQuantity) : 0}}件 <br>
                                      <template v-if="item.orderEstablishList[0]">
                                        剩余未核销数：{{item.orderEstablishList[0].restQuantity}} 件 <br>
                                      </template>
                                      销售商需支付金额：<span>{{item.order_bill_amount}} 元</span>
                                  </div>
                              </li>
                              <li class="sub-item" v-for="(check_ele, check_i) in item.orderEstablishList" :key="check_i + 1000">
                                    <div class="pdb-6">
                                        <span class="time">{{check_ele.order_submit_time}}</span>
                                        销售商第{{item.orderEstablishList.length - check_i}}次核销
                                    </div>  
                                    <div class="grey pdb-12">
                                        <!-- 核销时间：{{check_ele.order_submit_time}} <br> -->
                                        核销前未核销总数 {{check_ele.beforeOrderQuantity}} 件，核销 {{check_ele.orderEstablishQuantity}} 件，剩余未核销 {{check_ele.restQuantity}} 件。<br>
                                        核销应付款：{{check_ele.orderEstablishQuantity}}(件)x{{check_ele.unitPrice}}(元/件)x{{check_ele.supplierRate}}(%)= <span>{{check_ele.sumMoney}} 元</span>
                                    </div>    
                              </li>
                              
                          </ul>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div class="page-section" v-if="checkSaleHistory.length > 0">
            <div class="cg-mod-title mgt-0">核销记录</div>
            <ul class="time-line">
                <li class="item" v-for="(item, index) in checkSaleHistory" :key="index">
                    <div class="item-tail"></div>
                    <div class="item-node"></div>
                    <div class="item-content">
                        <div class="item-tit">
                            销售商第{{checkSaleHistory.length - index}}次核销
                        </div>
                        <div class="item-box">
                            <div class="grey">
                                核销时间：{{item.order_submit_time}} <br>
                                核销前未核销总数 {{item.beforeOrderQuantity}} 件，核销 {{item.orderEstablishQuantity}} 件，剩余未核销 {{item.restQuantity}} 件。<br>
                                核销应付款：{{item.orderEstablishQuantity}}(件)x{{item.unitPrice}}(元/件)x{{item.supplierRate}}(%)= <span>{{item.sumMoney}} 元</span>
                            </div>    
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div class="page-section">
            <div class="cg-mod-title mgt-0">下单订单明细</div>
            <div class="basic-info mgt-24">
                <el-row>
                    <el-col :span="8"><div class="line">
                        <span class="lab">下单订单号： </span>
                        <span class="val">{{orderDetail.order_number}}</span>
                    </div></el-col>
                    <el-col :span="16"><div class="line">
                        <span class="lab">下单时间：</span>
                        <span class="val">{{orderDetail.order_submit_time}} </span>
                    </div></el-col>
                    <el-col :span="8"><div class="line blue">
                        <span class="lab">下单时价格： </span>
                        <span class="val">{{orderDetail.item_order_price}}元/件</span>
                    </div></el-col>
                    <el-col :span="8"><div class="line blue">
                        <span class="lab">订单总计：</span>
                        <span class="val">{{orderDetail.order_purchase_quantity}}件</span>
                    </div></el-col>
                    <el-col :span="8"><div class="line blue">
                        <span class="lab">订单总价：</span>
                        <span class="val">{{orderDetail.order_purchase_amount}}元</span>
                    </div></el-col>
                </el-row>
            </div>
            <div class="take-order-table">
                <table class="table">
                    <thead>
                        <tr class="th">
                            <th width="15%">颜色</th>
                            <th width="25%">尺码</th>
                            <th width="25%">下单数量</th>
                            <th width="">小计</th>
                        </tr>
                    </thead>
                    <tbody v-for="(p_item, p_index) in orderSizeColorArr" :key="p_index">
                        <tr v-for="(s_item, s_index) in p_item.sizeArr" :key="s_index" >
                        <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.color}}</td>
                        <td>{{s_item.name}}</td>
                        <td>
                            {{s_item.number}}
                        </td>
                        <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.colorChoseTotal}}</td>
                        </tr>             
                    </tbody>
                </table>
            </div>
        </div>

        <div class="page-section" v-if="historyLockOrderList.length > 0">
            <div class="cg-mod-title mgt-0">锁仓订单明细</div>
            <div v-for="(item, index) in historyLockOrderList" :key="index">
                <div class="basic-info mgt-24">
                    <el-row>
                        <el-col :span="8"><div class="line">
                            <span class="lab">锁仓订单号： </span>
                            <span class="val">{{item.order_number}}</span>
                        </div></el-col>
                        <el-col :span="8"><div class="line">
                            <span class="lab">发起锁仓时间：</span>
                            <span class="val">{{item.reserve_order_submit_time}}</span>
                        </div></el-col>
                        <el-col :span="8"><div class="line">
                            <span class="lab"> 同意锁仓时间： </span>
                            <span class="val">{{item.reserve_order_last_update_time}}</span>
                        </div></el-col>
                        <el-col :span="8"><div class="line blue">
                            <span class="lab">下单时价格： </span>
                            <span class="val">{{item.item_order_price}}元/件</span>
                        </div></el-col>
                    </el-row>
                </div>
                <div class="take-order-table mgt-24">
                    <table class="table">
                        <thead>
                            <tr class="th">
                                <th width="20%">颜色</th>
                                <th width="20%">尺码</th>
                                <th width="30%">锁仓数</th>
                                <th width="">锁仓小计</th>
                            </tr>
                        </thead>               
                        <tbody v-for="(p_item, p_index) in item.group" :key="p_index">
                            <tr v-for="(s_item, s_index) in p_item.sizeArr" :key="s_index" >
                            <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.color}}</td>
                            <td>{{s_item.name}}</td>
                            <td>
                                {{s_item.sizelockNumber}}
                            </td>
                            <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.colorChoseTotal}}</td>
                            </tr>             
                        </tbody>
                    </table>
                </div>
                <div class="gap-line"></div>
            </div>
        </div>

        <!-- 确认平台结款凭证 -->
        <el-dialog
            title="确认平台结款凭证"
                :visible.sync="supplierSurePlatformPayPop"
                width="500px"
                :close-on-click-modal="false"
                class="cg-dialog"
            >
                <div class="cg-dialog-body">
                    <div class="line">下单订单号：<span class="black">{{orderDetail.order_number}}</span></div>
                    <div class="line pdb-20">商品款号：<span class="black">{{orderDetail.item_style_number}}</span></div>

                    <!-- <div class="line pdb-20">本次付款周期期间明细账单：</div>
                    <div class="line">已核销总数：<span class="black">--件</span></div>
                    <div class="line">剩余未核销数：<span class="black">--件</span></div>
                    <div class="line pdb-20">销售需支付金额：<span class="black">{{platformPeriodPayDetail.order_bill_amount}}元</span></div> -->
                    <div class="line">本期账单总金额：<span class="black">{{platformPopShowData.sumAmount}}元</span></div>
                    <div class="line">本期账单累计已支付：<span class="black">{{platformPopShowData.hadPaidAmount}}元</span></div>
                    <div class="line pdb-20">本期还需支付金额：<span class="red">{{platformPopShowData.restPayAmount}}元</span></div>

                    <div class="line">本次平台付款金额：<span class="black">{{platformPopShowData.currentPay}}元</span></div>
                    <div class="line">剩余欠款金额：<span class="red">{{platformPopShowData.debt}}元</span></div>
                </div>
                <div class="cg-dialog-footer">
                    <!-- <button class="cg-btn" @click="supplierSurePlatformPayPop=false">取消</button> -->
                    <button class="cg-btn red-border" @click="supplierRejectPlatformPay">未收到{{platformPopShowData.currentPay}}元，驳回要求重新提交</button>
                    <button class="cg-btn red mgl-16" @click="supplierSurePlatformPay">确认收到{{platformPopShowData.currentPay}}元</button>
                </div>
        </el-dialog>
        
        <!-- 发起清算 -->
        <el-dialog title="发起清算" :visible.sync="clearSurePop" width="1000px" center>
            <div class="clear-sure-top">
                <el-image
                    class="img"
                    :src="imgUrl"
                    fit="cover"
                >
                </el-image>
                <div class="info">
                    <span>名称：{{orderDetail.item_name}}</span> <br>
                    <span>款号：{{orderDetail.item_style_number}}</span>
                </div>
                <div class="count">共查询到{{clearOrderList.length}}条数据</div>
            </div>
            <el-table :data="clearOrderList" size="small">
                <el-table-column property="order_number" label="下单订单号" width="140"></el-table-column>
                <el-table-column property="order_purchase_quantity" label="下单数量"  width="80"></el-table-column>
                <el-table-column property="item_order_price" label="核销价(元)" width="80"></el-table-column>
                <el-table-column property="sumEstablishQuantity" label="已核销" width="80"></el-table-column>
                <el-table-column property="needPay" label="已出账单需支付" width="110"></el-table-column>
                <el-table-column property="sumPay" label="平台已确认金额" width="110"></el-table-column>
                <el-table-column property="amountToBeConfirmed" label="平台未确认金额" width="110"></el-table-column>
                <el-table-column property="unpaidAmount" label="已出账单欠款" width="100"></el-table-column>
                <el-table-column property="order_submit_time" label="下单时间" ></el-table-column>
            </el-table>
            
            <div slot="footer" class="dialog-footer">
                <el-button @click="clearSurePop = false">取 消</el-button>
                <el-button type="primary" @click="checkPaymentStatus">确认清算</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { 
    getReserverOrderInfo, getOrderEstablish, getBillList, confirmTransferPayment,
    getOrderPurchaseList, launchLiquidate, checkPaymentStatus
} from '../../../api/supplier'
import { supplierLockOrderState, supplierOrderState } from '../../../utils/order-state'
import { accMul, accDiv, accSub, computeSub } from '../../../utils/tools'
import NP from 'number-precision'
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            beCleared: false,  // 是否已转为清算
            status_pass: '',   // 核销状态描述
            status_pay: '',    // 付款状态描述

            // 下单订单详情
            orderDetail: {
                dealer_user_id: '',
                item_id: '',
                item_main_image_id: '',
                item_name: '',
                item_order_price: '',
                item_style_number: '',
                item_thumbnail_image_id: '',
                liquidateOrderId: '',
                liquidateOrderNumber: '',
                order_content: '',
                order_id: '',
                order_number: '',
                order_purchase_amount: '',
                order_purchase_quantity: '',
                order_state: '',
                order_submit_time: '',
                order_user_address_id: '',
                parent_order_id: '',
                productMainImageFile: '',
                supplier_user_id: '',
                sumEstablishQuantity: '',
                itemFeeSplitting: '',
                supplier_rate: '',
                dealer_rate: '',
                addressInfo: {
                    address_contact_name: "",
                    address_contact_phone: "",
                    address_string: "",
                    region_district_string: "",
                    region_city_string: "",
                    region_province_string: "",
                }
            },
            // 详情图片
            imgUrl: '',
            srcList: [],

            // 锁仓尺码数据
            lockSizeColorArr: [],

            // 下单尺码数据
            orderSizeColorArr: [],

            // 历史锁单列表
            historyLockOrderList: [],

            // 核销记录
            checkSaleHistory: [],

            // 账单列表
            billList_dealer: [],
            billList_platform: [],
            
            // 确认平台付款
            platformPeriodPayDetail: {},
            platformSinglePayDetail: {},
            platformPopShowData: {},
            supplierSurePlatformPayPop: false,

            // 清算确认弹框
            clearSurePop: false,
            clearOrderList: [],          
        }
    },
    computed: {
        ...mapGetters(['globalServiceCharge']),
        serviceFeeShow: function () {
            return NP.times(100, this.globalServiceCharge) + '%'
        },
    },
    created () {
        this.getReserverOrderInfo()
    },
    methods: {
        // 获取订单数据
        getReserverOrderInfo() {
            getReserverOrderInfo({
                orderPurchaseNumber: this.$route.query.orderNumber
            }).then(res => {
                console.log(res)
                if (res.errorCode == 200) {
                    let detail = res.data[0]
                    this.orderState = detail.order_state
                    this.orderDetail = detail
                    this.imgUrl = process.env.VUE_APP_IMG_PREV + detail.productMainImageFile
                    this.srcList.push(this.imgUrl)
                    
                    this.orderDetail.supplier_rate = this.orderDetail.itemFeeSplitting ? accMul(this.orderDetail.itemFeeSplitting.split(',')[1], 100) : ''
                    this.orderDetail.dealer_rate = this.orderDetail.itemFeeSplitting ? accMul(this.orderDetail.itemFeeSplitting.split(',')[0], 100) : ''
                    
                    if (this.orderDetail.liquidateState && this.orderDetail.liquidateState == '4') {
                        this.beCleared = true
                    } else {
                        this.beCleared = false
                    }

                    if (!this.orderDetail.sumEstablishQuantity) {this.status_pass = '从未核销'}
                    else if (this.orderDetail.sumEstablishQuantity < this.orderDetail.order_purchase_quantity) {this.status_pass = '部分核销'}
                    else if (this.orderDetail.sumEstablishQuantity == this.orderDetail.order_purchase_quantity) {this.status_pass = '全部核销'}

                    if (!this.orderDetail.paidAmount) {this.status_pay = '从未付款'}
                    else if (this.orderDetail.unpaidAmount > 0) {this.status_pay = '部分付款'}
                    else if (this.orderDetail.unpaidAmount == 0) {this.status_pay = '全部付款'}

                    try {
                        let group = JSON.parse(detail.order_content)
                        let arr = group.group
                        this.orderSizeColorArr = arr || []
                        console.log(this.orderSizeColorArr)
                    } catch (error) {
                        console.log(error)
                        this.orderSizeColorArr = []
                    }
                    
                    if (detail.reserverOrderInfoList && detail.reserverOrderInfoList.length > 0) {
                        this.historyLockOrderList = detail.reserverOrderInfoList.map(item => {
                            let group = []
                            try {
                                let order_content = JSON.parse(item.order_content)
                                group = order_content.group
                            } catch (error) {
                                console.log(error)
                            }
                            return {
                                ...item,
                                group
                            }
                        })
                    } 
                    console.log(this.historyLockOrderList)

                    this.getOrderEstablish(detail.order_id)
                    this.getBillList(1)
                    this.getBillList(2)
                }
            }).catch(err => {
                console.log(err)
            })
        },

        // 获取核销数据
        getOrderEstablish(orderId) {
            getOrderEstablish({
                orderId
            }).then(res => {
                console.log(res)
                if (res.errorCode == 200) {
                    let unitPrice,supplierRate,sumMoney
                    unitPrice = this.orderDetail.item_order_price
                    supplierRate = this.orderDetail.itemFeeSplitting ? this.orderDetail.itemFeeSplitting.split(',')[1] : ''
                   
                    
                    this.checkSaleHistory = res.data.map(item => {
                        let quantityObj = JSON.parse(item.order_content)
                        try {
                            let s1 = accMul(unitPrice, quantityObj.orderEstablishQuantity)
                            let s2 = accMul(s1, supplierRate)
                            sumMoney = s2.toFixed(2)
                        } catch (error) {
                            sumMoney = '--'
                        }
                        return {
                            ...item,
                            orderEstablishQuantity: quantityObj.orderEstablishQuantity,
                            beforeOrderQuantity: quantityObj.beforeOrderQuantity,
                            restQuantity: quantityObj.beforeOrderQuantity - quantityObj.orderEstablishQuantity,
                            unitPrice: unitPrice,
                            supplierRate: accMul(Number(supplierRate), 100),
                            sumMoney: sumMoney
                        }
                    })
                }
            }).catch(err => {
                console.log(err)
            })
        },
        // 获取账单信息  1 - 销售商  2 - 平台  3 - 清算账单
        getBillList(type) {
            getBillList({
                billType: type,
                orderPurchaseNumber: this.orderDetail.order_number,
                liquidateOrderId: this.orderDetail.lOrderId
            }).then(res => {
                console.log(res);
                if (res.errorCode == 200) {
                    if (type == 1) {
                        this.billList_dealer = res.data.map(element => {
                            return {
                                ...element,
                                order_bill_amount: (+element.order_bill_amount).toFixed(2),
                                order_pay_amount: (+element.order_pay_amount).toFixed(2) || 0,
                                rest_pay_amount: element.order_pay_amount ? (element.order_bill_amount - element.order_pay_amount).toFixed(2) : (+element.order_bill_amount).toFixed(2),
                                rest_pay_amount_subConfirm:computeSub(element.order_bill_amount,element.order_pay_amount,element.amountToBeConfirmed),
                                
                                orderEstablishList: element.orderEstablishList ? element.orderEstablishList.map(item => {
                                    let unitPrice, supplierRate, sumMoney;
                                    unitPrice = this.orderDetail.item_order_price;
                                    supplierRate = this.orderDetail.itemFeeSplitting
                                    ? this.orderDetail.itemFeeSplitting.split(",")[1]
                                    : "";
                                    let quantityObj = JSON.parse(item.order_content);
                                    try {
                                    let s1 = accMul(unitPrice, quantityObj.orderEstablishQuantity);
                                    let s2 = accMul(s1, supplierRate);
                                    sumMoney = s2.toFixed(2);
                                    } catch (error) {
                                    sumMoney = "--";
                                    }
                                    return {
                                    ...item,
                                    orderEstablishQuantity: quantityObj.orderEstablishQuantity,
                                    beforeOrderQuantity: quantityObj.beforeOrderQuantity,
                                    restQuantity:
                                        quantityObj.beforeOrderQuantity -
                                        quantityObj.orderEstablishQuantity,
                                    unitPrice: unitPrice,
                                    supplierRate: accMul(Number(supplierRate), 100),
                                    sumMoney: sumMoney
                                    };
                                }).reverse() : [],
                                orderPaymentList: element.orderPaymentList ? element.orderPaymentList.map(item => {
                                    return {
                                    ...item,
                                    imageFiles: item.image_file ? item.image_file.split(',').map(ele => ele ? process.env.VUE_APP_IMG_PREV + ele : '') : []
                                    }
                                }) : []
                            }
                        });
                  
                    }
                    if (type == 2) {
                        this.billList_platform = res.data.map(element => {
                            return {
                            ...element,
                            order_bill_amount: (+element.order_bill_amount).toFixed(2),
                            order_pay_amount: (+element.order_pay_amount).toFixed(2) || 0,
                            rest_pay_amount: element.order_pay_amount ? (element.order_bill_amount - element.order_pay_amount).toFixed(2) : element.order_bill_amount.toFixed(2),
                            orderTransferList: element.orderTransferList ? element.orderTransferList.map(item => {
                                return {
                                ...item,
                                imageFiles: item.image_file ? item.image_file.split(',').map(ele => ele ? process.env.VUE_APP_IMG_PREV + ele : '') : []
                                }
                            }) : []
                            }
                        });
                    }
                    
                } else {
                    
                }
            }).catch(err => {
                console.log(err)
            })
        },

        // 平台付款明细
        getPlatformPayDetail (item, pay_ele) {
            this.platformPeriodPayDetail = item;
            this.platformSinglePayDetail = pay_ele;
            this.platformPopShowData = {
                sumAmount: (+item.order_bill_amount).toFixed(2),
                hadPaidAmount: (+item.order_pay_amount).toFixed(2),
                restPayAmount: (item.order_bill_amount - item.order_pay_amount).toFixed(2),
                currentPay: (+pay_ele.order_payment_amount).toFixed(2),
                debt: (item.order_bill_amount - item.order_pay_amount - pay_ele.order_payment_amount).toFixed(2)
            }
            this.supplierSurePlatformPayPop = true;
        },
        // 确认销售商付款
        supplierSurePlatformPay() {
            confirmTransferPayment({
                "supplierUserId": this.orderDetail.supplier_user_id,
                "dealerUserId": this.orderDetail.dealer_user_id,
                "orderPurchaseNumber": this.orderDetail.order_number,
                "transferBillOrderId": this.platformSinglePayDetail.bill_order_id,
                "orderTransferNumber": this.platformSinglePayDetail.order_number,
                "transferPaymentState": "y"
            }).then(res => {
                console.log(res);
                if (res.errorCode == 200) {
                    this.supplierSurePlatformPayPop = false
                    this.$message.success('操作成功')
                    this.getBillList(1)
                    this.getBillList(2)
                } else {
                    this.$message.error(res.errorMsg || '操作失败') 
                }
            }).catch(err => {
                console.log(err)
            })
        },
        // 拒绝 销售商付款
        supplierRejectPlatformPay() {
            confirmTransferPayment({
                "supplierUserId": this.orderDetail.supplier_user_id,
                "dealerUserId": this.orderDetail.dealer_user_id,
                "orderPurchaseNumber": this.orderDetail.order_number,
                "transferBillOrderId": this.platformSinglePayDetail.bill_order_id,
                "orderTransferNumber": this.platformSinglePayDetail.order_number,
                "transferPaymentState": "n"
            }).then(res => {
                console.log(res);
                if (res.errorCode == 200) {
                    this.supplierSurePlatformPayPop = false
                    this.$message.success('操作成功')
                    this.getBillList(1)
                    this.getBillList(2)
                } else {
                    this.$message.error(res.errorMsg || '操作失败') 
                }
            }).catch(err => {
                console.log(err)
            })
        },
        // 发起清算
        toStartClear(row) {
            this.clearSurePop = true
            this.getCanClearOrder()
        },
        // 获取可清算订单
        getCanClearOrder() {
            getOrderPurchaseList({
                "supplierUserId": this.orderDetail.supplier_user_id,
                "dealerUserId": this.orderDetail.dealer_user_id,
                "itemId":this.orderDetail.item_id
            }).then(res => {
                
                console.log('getOrderPurchaseList', res)
                if (res.errorCode == 200) {
                    this.clearOrderList = res.data
                } else {
                    this.$message.error(res.errorMsg || '获取数据失败')
                }
            }).catch(err=> {
                
                console.log(err)
            })
        },
        // 检查检查有没有付款没有确认的订单
        checkPaymentStatus() {
            checkPaymentStatus({
                "supplierUserId": this.orderDetail.supplier_user_id,
                "dealerUserId": this.orderDetail.dealer_user_id,
                "itemId": this.orderDetail.item_id
            }).then(res => {
                console.log(res)
                if (res.errorCode == 200) {
                    this.launchLiquidate()
                } else {
                    this.$message.error(res.errorMsg || '网络异常')
                    // -19999 还有付款信息没有确认
                }
            })
            .catch(err => {
                console.log(err);
            })
        },
        // 发起清算 api
        launchLiquidate() {
            launchLiquidate({
                "supplierUserId": this.orderDetail.supplier_user_id,
                "dealerUserId": this.orderDetail.dealer_user_id,
                "itemId": this.orderDetail.item_id,
                "orderState": "2",
                // "liquidateOrderId":"",
                "orderSubmitType": "supplier"
            })
            .then(res => {
                console.log(res);
                if (res.errorCode == 200) {
                    this.$message.success(res.errorMsg || "操作成功");
                    this.clearSurePop = false
                    this.clearOrderList = []
                    this.getReserverOrderInfo();
                } else {
                    this.$message.error(res.errorMsg || "操作是失败");
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        // 跳转清算页面
        toClearPage () {
            this.$router.push('/supplier/order/detail-clear?orderId=' + this.orderDetail.liquidateOrderId)
        }
    }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
    min-width: 1030px;
}
.test-btns {
    position:absolute; right: 10px; top: 10px;
}
.page-section {
    padding: 24px 24px;
    background: #fff;
    margin-bottom: 16px;
}
.header-handle-box {
    min-width: 980px;
    box-sizing: border-box;
    margin-top: 24px;
    border: 1px solid #e6e6e6;
    background: #fafafa;
    padding: 40px 80px;
    .state {
        font-size: 20px;
        color: #333;
        font-weight: 500;
        &.red {color: #F81D22;}
    }
    .btns {
        margin-top: 40px;
        .cg-btn {margin-right: 20px;}
    }
    .tip {
        margin-top: 14px;
        height:20px;
        font-size:14px;
        color:rgba(51,51,51,0.6);
        line-height:20px;
    }
    .tip-small {
        margin-left: 8px;
        height:20px;
        font-size:14px;
        color:rgba(51,51,51,0.6);
        font-size: normal;
        line-height:20px;
    }
}
.basic-info {
    &.mgt-24 {
        margin-top: 24px;
    }
    &.mgt-40 {
        margin-top: 40px;
    }
    .line {
      padding-bottom: 16px;
      font-size:14px;
      line-height:22px;
      .lab {
        color:rgba(0,0,0,0.85);
      }
      .val {
        color:rgba(0,0,0,0.65);
      }
      &.blue .lab , &.blue .val { color: #1890FF}
      .green { color: #52C41A;}
      .text-btn {
          margin-left: 16px;
          background: transparent;
          border: none;
          font-size: 14px;
          color: #1890FF;
          outline: none;
          cursor: pointer;
          &:hover {
              text-decoration: underline;
          }
      }
    }
}
.order-detail-table {
    margin-top: 24px;
    .table {
        border: 1px solid #E6E6E6;
        width: 100%;
        min-width: 980px;
        border-spacing: 0;
        border-collapse: collapse;
        font-size:14px;
        tr.th {
            background: #fafafa;
            height: 55px;
        }
        tr th {
            color:rgba(0,0,0,0.85);
            font-weight: normal;
        }
        td {
            padding: 32px 24px 0;
            color:rgba(0,0,0,0.85);
            text-align: center;
            vertical-align: top;
        }
        tr:last-child td {
            padding-bottom: 32px;
        }
        .td-1-wrap {
            height: 100px;
            .img {
                border: 1px solid #f0f0f0;
                float: left;
                width: 100px;
                height: 100px;
                margin-right: 24px;
            }
            .title {
                text-align: left;
            }
        }
    }
    .rate-info {
        margin-top: 15px;
    }
}
.goods-size-list {
    border: 1px solid #E6E6E6;
    border-top: none;
    &.mgt-24 {
        margin-top: 24px;
    }
    .color-list {
        .color-head {
            color:rgba(0,0,0,0.85);
            font-weight: normal;
            height: 50px;
            padding: 0 80px 0 48px;
            line-height: 50px;
            border-bottom: 1px solid #E6E6E6;
            border-top: 1px solid #E6E6E6;
            background: #fafafa;
            .t1 {float: left; width: 300px;}
            .t2 {float: left;}
        }
        .size-wrap {
            padding: 24px 24px 0 48px;
        }
        .size-list {
            th, td {
                width: 100px;
                padding: 0 0 24px 0;
                font-size: 14px;
                color:rgba(0,0,0,0.85);
            }
            th {
                text-align: left;
                font-weight: normal;
            }
        }
    }
}

.agree-lock-tips {
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    padding-bottom: 10px;
}
.take-order-table {
  &.scroll {
      height: 50vh;
      overflow-y: auto;
      overflow-x: visible;
  }
  .table {
    border: 1px solid #E6E6E6;
    width: 100%;
    min-width: 980px;
    border-spacing: 0;
    border-collapse: collapse;
    font-size:14px;
    tr {
      height: 50px;
    }
    tr.th {
      background: #fafafa;
    }
    tr th {
      color:rgba(0,0,0,0.85);
      font-weight: normal;
    }
    td {
      border: 1px solid #E6E6E6;
      text-align: center;
      color:rgba(0,0,0,0.85);
    }
    &.min-400 {
        min-width: 400px;
    }
  }
  &.mgt-24 {
      margin-top: 24px;
  }
  &.clearing {
      margin-top: 24px;
  }
  &.clearing tr th {
    border: 1px solid #E6E6E6;
  }
  &.clearing tr th:last-child, &.clearing tr td:last-child{
    color: #F81D22;
  }
  
}

.gap-line {
    margin: 40px 0;
    height: 1px;
    background: #E6E6E6;
}

.time-line {
  margin-top: 24px;
  list-style: none;
  .item {
    position: relative;
    .item-tail {
      position: absolute;
      top: 6px;
      left: 4px;
      width: 2px;
      height: 100%;
      background: #f7f7f7;
    }
    .item-node {
      position: absolute;
      top: 6px;
      left: 0;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #d9d9d9;
    }
    &:first-child .item-node {
      background: #F81D22;
    }
    &:last-child .item-tail {
      width: 0;
    }
    .item-content {
      padding-left: 32px;
      font-size: 14px;
      font-weight: 500;
      width: 800px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 24px;
      padding-bottom: 16px;
    }
    .item-tit {
      padding-bottom: 26px;
      .item-tit-strong {
          font-size: 20px;
          color: #000;
          font-weight: bold;
      }
      .item-tit-during {
          font-size: 15px;
          color: #666;
      }
    }
    .item-sum-data {
        background: rgba(5, 4, 4, 0.02);
        padding: 24px 24px 16px;
        position: relative;
        font-size: 16px;
        .val {
            font-weight: bold;
        }
        &::after {
            content: ' ';
            height: 1px;
            border-bottom: 1px dashed #ccc;
            position: absolute;
            left: 24px;
            right: 24px;
            bottom: 0;
        }
    }
    .item-box {
      background: rgba(5, 4, 4, 0.02);
      border-radius: 2px;
      padding: 24px;
      margin-bottom: 20px;
      .img {
        width: 100px; height: 100px; border: 1px solid #eee;
        vertical-align: top; margin-right: 4px;
      }
      .pay-info {
        display: inline-block;
        width: 400px;
        margin-left: 10px;
        font-size: 13px;
      }
      .pdb-12 {
        padding-bottom: 12px;
      }
      .pdb-6 {
        padding-bottom: 6px;
      }
      .grey {
        color: rgba(0, 0, 0, 0.45);
      }
      .green {
        color: #52c41a;
      }
      .blue {
        color: #1890ff;
      }
    }
  }
  .sub-time-line {
    list-style: none;
    .sub-item {
      position: relative;
      padding-left: 24px;
      .title {
        display: inline-block;
        width: 450px;
      }
      .time {font-size: 13px; color: #000; margin-right: 6px;}
      &::before {
        content: " ";
        position: absolute;
        top: 15px;
        left: 3px;
        width: 1px;
        height: calc(100% - 12px);
        background: #d8d8d8;
      }
      &::after {
        content: " ";
        position: absolute;
        top: 6px;
        left: 0;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #fff;
        border: 1px solid #d8d8d8;
        box-sizing: border-box;
      }
      &:first-child::after {
        background: #ff9c6e;
        border: 1px solid #ff9c6e;
      }
      &:last-child::before {
        width: 0;
      }
    }
  }
}

.address-wrap {
    padding-top: 16px;
}
.address-label {
    font-size: 14px;
    font-weight: 500;
    color: #666;
    line-height: 30px;
}
.address-content {
    padding: 6px 0px ;
    color: #333;
    font-size: 13px;
    .line {
        margin-bottom: 6px;
        &:last-child {margin-bottom: 0;}
    }
    .gap {
        margin-left: 30px;
    }
}

.clear-sure-top {
    height: 64px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e6e6e6;
    position: relative;
    .img {width: 64px; height: 64px; float: left; border: 1px solid #eee}
    .info {padding-left: 80px;}
    .count {position: absolute; right: 0; bottom: 10px; font-size: 12px; color: #333; line-height: 1;}
}

</style>